import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IndirectTaxProductsResponse,
  UseIndirectTaxProductsParams,
} from './types';

export function useIndirectTaxProducts({
  token,
  filters,
  search_term,
  cursor = null,
  limit = 10,
}: UseIndirectTaxProductsParams) {
  const query = new URLSearchParams();

  if (filters.corporationId !== undefined) {
    query.append('corporationId', filters.corporationId.toString());
  }

  if (cursor) {
    query.append('cursor', cursor);
  }

  if (filters.tax_codes) {
    const taxCodes = Array.isArray(filters.tax_codes)
      ? filters.tax_codes.join(',')
      : filters.tax_codes;
    query.append('tax_codes', taxCodes);
  }

  if (search_term) {
    query.append('search_term', search_term);
  }

  query.append('limit', limit.toString());

  const { data, error, isLoading, mutate } = useSWR<IndirectTaxProductsResponse>(
    `new-sales-tax/products?${query}`,
    SWRFetcher({ method: 'GET' }, token),
    { keepPreviousData: true }
  );

  return {
    data: data
      ? {
          products: data.data,
          nextCursor: data.nextCursor,
          totalProducts: data.totalProducts,
        }
      : {
          products: [],
          nextCursor: null,
          totalProducts: 0,
        },
    mutate,
    error,
    isLoading,
  };
}
